//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.MillCutParameters.js";
import "../CAM/CAM.FeedsBuilder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.ArcOutputTypeCiBuilder.js";
let d=[[[1,"CutParameters",0,"CAM.MillCutParameters",0],[0,"DrivePoint",1,0],[1,"FeedsBuilder",0,"CAM.FeedsBuilder",0],[1,"MinCutLength",0,"CAM.InheritableToolDepBuilder",0],[1,"MotionOutput",0,"CAM.ArcOutputTypeCiBuilder",0],[0,"ReferenceTool",1,"CAM.Tool",0],[0,"WallCleanupType",1,0]],[[["drivePointSpecified"],"SetDrivePointSpecified",{},1,0]],[]];
SPLM.CAM.MillOperationBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.MillOperationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.MillOperationBuilder.WallCleanupTypes = Object.freeze({
    "None" : "None", "AtStart" : "AtStart", "AtEnd" : "AtEnd", "Automatic" : "Automatic"});

export default SPLM;